module.exports = __webpack_public_path__ + "static/img/piliangshanchu.15aabbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/piliangshanchu.png
// module id = 8zD4
// module chunks = 24